export default __webpack_public_path__ + "static/media/img-0783-portugal-full-face.c1fe7eb6.png";